import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LanguageCode, LanguageCodeUpper } from '@digilize/shared/definitions/src';
import { I18nService, LangOption } from '@digilize/shared/feature/modules/i18n/src';
import { TranslocoService } from '@ngneat/transloco';
import { map, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'lib-lang-droplist',
  templateUrl: './lang-droplist.component.html',
  styleUrls: ['./lang-droplist.component.scss'],
})
export class LangDroplistComponent implements OnInit, OnDestroy {
  @Input() dropdownIconsPath: string;
  langFormControl: FormControl;
  defaultLang = '';
  langOptions$: Observable<LangOption[]> = this.i18nService.langToChooseFrom$.pipe(
    map((lang) =>
      lang.map((lang) => {
        return { key: lang.code.toUpperCase() as LanguageCodeUpper, value: lang.code, img: lang.iconFlagPath };
      })
    )
  );
  constructor(private translocoService: TranslocoService, private i18nService: I18nService) {}
  subSink: Subscription[] = [];

  ngOnInit(): void {
    this.langFormControl = new FormControl((this.defaultLang = this.translocoService.getDefaultLang()));
    this.subSink.push(
      this.translocoService.langChanges$.subscribe((lang) => {
        this.langFormControl.setValue(lang);
      })
    );
  }

  handleLangChange(lang: LanguageCode) {
    this.langFormControl.setValue(lang);
    this.i18nService.setLangAndSave(lang);
  }

  getLangOption(lang: LanguageCode, langOptions: LangOption[]): LangOption {
    return langOptions.find((option) => option.value === lang);
  }

  ngOnDestroy(): void {
    this.subSink.forEach((sub) => sub.unsubscribe());
  }
}
